// @flow
import styled from 'styled-components';

export const TradeContent = styled.div`
	background: #F8F8FA;
	margin-bottom: ${({ no_margin }) => no_margin ? 0 : '20px'};
`;

export default TradeContent;


// WEBPACK FOOTER //
// ./src/components/Trades/TradeContent.js